export enum FeedActionType {
    None,
    PromptUpdateNativeHost,
    PromptLoadServiceRequestFailure,
}

export interface FeedAction {
    promptFeedAction: boolean;
    type: FeedActionType;
    feedActionCallback(): void;
}
